import React from "react";
import { Link } from "react-router-dom";
import {
  Camera,
  ShieldCheck,
  Users,
  FileBarChart2,
  Archive,
  Target,
  ClipboardCheck,
} from "lucide-react";
import "./NavbarEnlaces.css";

// Ícono de Procesos Electorales (Urna) con trazos 2D para renderizado íntegro con gradientes SVG
const VoteIcon = ({ size = 34, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m9 12 2 2 4-4" />
    <path d="M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z" />
    <path d="M22 18.999L2 19.001" />
  </svg>
);

// Ícono de Normatividad (Balanza) con poste y base 2D para renderizado íntegro con gradientes SVG
const ScaleIcon = ({ size = 34, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Poste central vertical con micro-dimensión para cálculo de gradiente en SVG */}
    <path d="M11.999 3L12.001 21" />
    {/* Platillo derecho */}
    <path d="m19 8 3 8a5 5 0 0 1-6 0zV7" />
    {/* Brazo horizontal */}
    <path d="M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1" />
    {/* Platillo izquierdo */}
    <path d="m5 8 3 8a5 5 0 0 1-6 0zV7" />
    {/* Base horizontal con micro-dimensión para cálculo de gradiente en SVG */}
    <path d="M7 20.999L17 21.001" />
  </svg>
);

const enlaces = [
  {
    to: "/ProcesosElectorales",
    label: "Procesos Electorales",
    lines: ["Procesos", "Electorales"],
    Icon: VoteIcon,
  },
  {
    to: "/Normatividad",
    label: "Normatividad",
    lines: ["Normatividad"],
    Icon: ScaleIcon,
  },
  {
    to: "/Galeria",
    label: "Galería Fotográfica",
    lines: ["Galería", "Fotográfica"],
    Icon: Camera,
  },
  {
    to: "/OIC",
    label: "Órgano Interno de Control",
    lines: ["Órgano Interno", "de Control"],
    Icon: ShieldCheck,
  },
  {
    to: "/PartidosPoliticos",
    label: "Partidos Políticos",
    lines: ["Partidos", "Políticos"],
    Icon: Users,
  },
  {
    to: "/Infografias",
    label: "Infografías",
    lines: ["Infografías"],
    Icon: FileBarChart2,
  },
  {
    to: "/MemoriasElectorales",
    label: "Memorias Electorales",
    lines: ["Memorias", "Electorales"],
    Icon: Archive,
  },
  {
    to: "/MetasMSPEN",
    label: "SPEN",
    lines: ["SPEN"],
    Icon: Target,
  },
  {
    to: "/Informes",
    label: "Encuestas y Sondeos de opinión",
    lines: ["Encuestas y Sondeos", "de opinión"],
    Icon: ClipboardCheck,
  },
];

const NavbarEnlaces = (props) => {
  return (
    <>
      <div className="w-100 NavbarEnlaces__container mb-4">
        {/* Definición única del gradiente para iconos SVG con stroke */}
        <svg
          width="0"
          height="0"
          style={{ position: "absolute", pointerEvents: "none" }}
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="navbarEnlacesGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#A90786" />
              <stop offset="100%" stopColor="#5A2C6E" />
            </linearGradient>
          </defs>
        </svg>

        <div className="NavbarSubpageEnlaces">
          {enlaces.map(({ to, label, lines, Icon }, index) => (
            <Link
              key={index}
              to={to}
              className="NavbarEnlaces__card NavbarEnlaces__link rounded-4 text-decoration-none"
              title={label}
            >
              <div className="NavbarEnlaces__iconWrapper NavbarEnlaces__icon-wrapper">
                <Icon
                  className="NavbarEnlaces__icon"
                  size={34}
                  strokeWidth={1.8}
                  stroke="url(#navbarEnlacesGradient)"
                />
              </div>
              {lines.length > 0 && (
                <div className="NavbarEnlaces__label-wrapper">
                  <span className="NavbarEnlaces__label">
                    {lines.map((line, idx) => (
                      <span key={idx} className="NavbarEnlaces__label-line">
                        {line}
                      </span>
                    ))}
                  </span>
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
      {props.title && <div className="Enlances__title mb-4">{props.title}</div>}
    </>
  );
};

export default NavbarEnlaces;
